import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Printer, UserCheck, Images } from 'lucide-react';
import HeroVideo from './HeroVideo';

/** Entrada escalonada: cada bloque entra un poco después del anterior. */
const step = (ms: number) => ({ animationDelay: `${ms}ms`, animationFillMode: 'both' as const });

const Hero: React.FC = () => (
  <section className="relative flex h-[88vh] min-h-[560px] items-center justify-center overflow-hidden bg-black">
    <HeroVideo />

    <div className="container relative z-10 mx-auto max-w-5xl px-6 text-center text-white">
      <p
        className="animate-fade-in-up mb-6 text-xs font-bold uppercase tracking-[0.4em] text-cabina-cream/90 md:text-sm"
        style={step(120)}
      >
        Experiencias inolvidables
      </p>

      <h1
        className="animate-fade-in-up mb-8 font-serif text-fluid-hero font-bold uppercase leading-tight drop-shadow-2xl"
        style={step(260)}
      >
        Cabinas de fotos, videos,
        <br />
        <span className="bg-gradient-to-r from-white via-cabina-cream to-white bg-clip-text italic text-transparent">
          Gifs &amp; Boomerangs
        </span>
      </h1>

      <p
        className="animate-fade-in-up mx-auto mb-12 max-w-3xl text-lg font-light text-gray-100 drop-shadow-md md:text-2xl"
        style={step(400)}
      >
        Haz que tu evento sea eterno. Capturamos la magia de tus invitados con la mejor
        tecnología de Colombia.
      </p>

      <div
        className="animate-fade-in-up flex flex-col justify-center gap-5 md:flex-row md:gap-6"
        style={step(540)}
      >
        <Link to="/contacto" className="btn-cdf">
          Reservar fecha
        </Link>
        <Link to="/catalogo" className="btn-ghost-cdf">
          Ver catálogo
        </Link>
      </div>

      {/* Lo que incluye el alquiler (lo mismo que dice la respuesta corta),
          como el talón de una tirilla impresa. */}
      <ul
        className="animate-fade-in-up mx-auto mt-10 hidden max-w-fit flex-wrap sm:flex items-center justify-center gap-x-5 gap-y-2.5 rounded-[3px] border border-white/20 bg-black/35 px-5 py-3 text-[10px] font-bold uppercase tracking-[0.18em] text-white/90 backdrop-blur-md sm:text-[11px] md:mt-14 md:gap-x-7 md:px-7"
        style={step(700)}
      >
        <li className="flex items-center gap-2">
          <Printer size={14} className="text-cabina-cream" aria-hidden="true" />
          Impresión ilimitada
        </li>
        <li className="flex items-center gap-2">
          <UserCheck size={14} className="text-cabina-cream" aria-hidden="true" />
          Operador incluido
        </li>
        <li className="flex items-center gap-2">
          <Images size={14} className="text-cabina-cream" aria-hidden="true" />
          Galería digital
        </li>
      </ul>
    </div>

    <div
      className="animate-fade-in-up absolute inset-x-0 bottom-7 z-10 flex justify-center"
      style={step(950)}
      aria-hidden="true"
    >
      <ChevronDown size={26} className="scroll-cue text-white/70" />
    </div>
  </section>
);

export default Hero;
